// ReCharge Portal Redesign
// Enable via Theme Settings → ReCharge Portal Redesign

(function () {
	const isPortalPage = window.location.pathname.includes(
		"/tools/recurring/portal",
	);
	const isReferralsPage = window.location.pathname.includes(
		"/tools/recurring/pages/referrals",
	);

	let css = "";

	if (isPortalPage) {
		css += `
      #recharge-customer-portal > div > div {
        font-family: "TTNorms" !important;
      }

      #recharge-customer-portal .recharge-container {
        background: #f4f2ecf9 !important;
        position: relative;
      }

      #recharge-customer-portal .recharge-container:before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: #e8e3d4f0;
        z-index: -1;
      }

      #recharge-customer-portal button {
        background: linear-gradient(82.99deg, #e7b858 11.19%, #f6e7a8 50.59%, #eece7e 69.83%, #e8be62 85.4%, #e7b858 94.57%);
        border: 0;
        color: #043f25;
        border-radius: 0;
      }

      :root {
        --recharge-color-brand: #043f25 !important;
        --recharge-corners-radius: 0 !important;
      }
    `;
	}

	if (isReferralsPage) {
		css += `
      .recharge-theme {
        --recharge-typography-heading-font-family: "TTNorms" !important;
        --recharge-typography-body-font-family: "TTNorms" !important;
      }

      #recharge-onsite {
        background: none !important;
      }

      #recharge-onsite:before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: #e8e3d4f0;
        z-index: -1;
      }

      .recharge-theme>div>div>div>div>div {
        background: none !important;
      }

      .recharge-theme button {
        background: linear-gradient(82.99deg, #e7b858 11.19%, #f6e7a8 50.59%, #eece7e 69.83%, #e8be62 85.4%, #e7b858 94.57%);
        border: 0;
        color: #043f25;
        border-radius: 0;
        text-transform: uppercase;
      }

      .recharge-theme button:hover, .recharge-button.recharge-button-tertiary:hover {
        scale: 1.05;
        transition: 0.3s;
      }

      .recharge-theme img {
        border-radius: 0;
      }

      .recharge-button.recharge-button-tertiary {
        color: #043f25;
        text-decoration: underline;
        text-underline-offset: 3px;
        text-decoration-thickness: 1px;
        text-decoration-color: #043f25;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-skip-ink: none;
      }
    `;
	}

	if (css) {
		const style = document.createElement("style");
		style.id = "rc-portal-redesign";
		style.textContent = css;
		document.head.appendChild(style);
	}

	if (isReferralsPage) {
		const patchInputs = () => {
			const inputs = document.querySelectorAll('#recharge-onsite input');
			if (inputs.length === 0) return false;

			for (const input of inputs) {
				const parent = input.parentElement;
				if (!parent || parent.dataset.rcPatched) continue;
				parent.dataset.rcPatched = '1';
				Object.assign(parent.style, {
					backgroundColor: '#fff',
					border: '0',
					borderRadius: '0',
				});
			}

			for (const input of inputs) {
				const parent = input.parentElement;
				if (!parent) continue;
				parent.style.outlineOffset = '0';
				input.addEventListener('focus', () => {
					parent.style.outline = '1px solid lightgrey';
				});
				input.addEventListener('blur', () => {
					parent.style.outline = '';
				});
			}
			return true;
		};

		const wait = setInterval(() => {
			if (patchInputs()) clearInterval(wait);
		}, 500);

		setTimeout(() => clearInterval(wait), 15000);
	}
})();
